import clsx from "clsx";
import { useMemo } from "react";

import { PROPERTY_VISIBILITY, PROPERTY_VISIBILITY_OPTIONS } from "constants/property";
import { PropertyVisibility } from "graphql/type.ts";

const VisibilityTag = ({ visibility }: { visibility: PropertyVisibility }) => {
  const tagOptions = useMemo(
    () => ({
      [PROPERTY_VISIBILITY.Public]: {
        text: PROPERTY_VISIBILITY_OPTIONS[0].label,
        colorClass: "text-black",
        dotClass: "bg-attention",
      },
      [PROPERTY_VISIBILITY.Limited]: {
        text: PROPERTY_VISIBILITY_OPTIONS[1].label,
        colorClass: "text-black",
        dotClass: "border border-attention border-2",
      },
      [PROPERTY_VISIBILITY.Private]: {
        text: PROPERTY_VISIBILITY_OPTIONS[2].label,
        colorClass: "text-disabled",
        dotClass: "bg-disabled",
      },
    }),
    []
  );

  if (!visibility) return null;

  return (
    <div className="flex items-center gap-[5px]">
      <span className={clsx(tagOptions[visibility].dotClass, "h-[10px] w-[10px] rounded-full")} />
      <span className={clsx("text-sm", tagOptions[visibility].colorClass)}>{tagOptions[visibility].text}</span>
    </div>
  );
};

export default VisibilityTag;
